import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=020966dd&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=020966dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020966dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020966dd')) {
      api.createRecord('020966dd', component.options)
    } else {
      api.reload('020966dd', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=020966dd&scoped=true&", function () {
      api.rerender('020966dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20C1P7QHSytDB/JS/comp/SearchFilterTokens.vue"
export default component.exports